export enum ReceiverTypes {
    sgtcp = "SG-TCP",
    pstn = "PSTN",
    stages = "STAGES",
    rapidRspWest = "RAPID-RESPONSE-WEST",
    rapidRspEast = "RAPID-RESPONSE-EAST",
    matrix = "MATRIX",
}

export enum ReceiverDescription {
    IP = "IP Receiver",
    STAGE_XML = "Stages XML Receiver",
    RR_DEFAULT = "Rapid Response",
    RR_WEST = "Rapid Response West",
    RR_EAST = "Rapid Response East",
}
